<template>
  <div id="app">

     <router-view  > </router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.el-collapse {
  text-indent: 20px;
  border-top: 1px solid #4465b1;

}
.el-collapse-item__header {
  background-color:#1f4169;
  color:#FFFFFF;

} 
.el-collapse-item__wrap{
  border-bottom: 1px solid #364a79;
  border-top: 1px solid #364a79;
  background-color:#042442;
}
</style>



// WEBPACK FOOTER //
// src/App.vue